import { gql } from '@apollo/client';

export const GET_INSTITUTION_AND_CONNECTION_DETAILS_FOR_BORROWER = gql`
  query GetInstitutionAndConnectionDetailsForBorrowerId($borrowerId: UUID!) {
    institutionAndConnectionDetailsForBorrower(borrowerId: $borrowerId) {
      creditFacilityId
      creditFacilitySlug
      creditFacilityName
      organizations {
        id
        name
        slug
        type
      }
      tellerBankInstitutionId
      tellerBankInstitutionName
      tellerBankInstitutionKey
      tellerItemId
      tellerAccountId
      tellerAccountName
      tellerAccountMask
      plaidBankInstitutionId
      plaidBankInstitutionName
      plaidBankInstitutionKey
      plaidItemId
      plaidAccountId
      plaidAccountName
      plaidAccountMask
    }
  }
`;

export const GET_ALL_BANK_INSTITUTIONS = gql`
  query GetAllBankInstitutions {
    allBankInstitutions {
      id
      name
      bankInstitutionKey
      tellerInstitutionId
      plaidInstitutionId
    }
  }
`;

export const GET_BANK_ACCOUNTS_BY_CREDIT_FACILITY_ID = gql`
  query GetBankAccountsByCreditFacilityId(
    $organizationId: UUID!
    $creditFacilityId: UUID!
    $maskSensitiveInfo: Boolean
  ) {
    bankAccountsWithDesignationAndOwner(
      organizationId: $organizationId
      creditFacilityId: $creditFacilityId
      maskSensitiveInfo: $maskSensitiveInfo
    ) {
      id
      accountNumber
      name
      bankInstitutionId
      plaidAccountId
      tellerAccountId
      retrievedAt
      current
      available
      routingNumber
      institutionName
      bankInstitutionKey
      organizationId
      ownerType
      accountType
      creditFacilityId
      ownerName
      connectionProviderName
      connectionProviderAccountMask
    }
  }
`;

export const ADD_BANK_ACCOUNT = gql`
  mutation AddBankAccount(
    $bankInstitutionId: UUID!
    $accountName: String!
    $accountNumber: String!
    $routingNumber: String!
    $ownerId: UUID!
    $plaidAccountId: String
    $tellerAccountId: String
  ) {
    addBankAccount(
      bankInstitutionId: $bankInstitutionId
      accountName: $accountName
      accountNumber: $accountNumber
      routingNumber: $routingNumber
      ownerId: $ownerId
      plaidAccountId: $plaidAccountId
      tellerAccountId: $tellerAccountId
    ) {
      response
    }
  }
`;

export const EDIT_BANK_ACCOUNT = gql`
  mutation EditBankAccount(
    $bankAccountId: UUID!
    $accountName: String!
    $ownerId: UUID!
    $plaidAccountId: String
    $tellerAccountId: String
  ) {
    editBankAccount(
      bankAccountId: $bankAccountId
      accountName: $accountName
      ownerId: $ownerId
      plaidAccountId: $plaidAccountId
      tellerAccountId: $tellerAccountId
    ) {
      response
    }
  }
`;

export const GET_BANK_ACCOUNTS_WITH_INSTITUTION_AND_OWNER_BY_ORGANIZATION_ID = gql`
  query getBankAccountsWithInstitutionAndOwnerByOrganizationId(
    $organizationId: UUID!
    $maskSensitiveInfo: Boolean
  ) {
    bankAccountsWithInstitutionAndOwnerByOrganizationId(
      organizationId: $organizationId
      maskSensitiveInfo: $maskSensitiveInfo
    ) {
      id
      accountNumber
      name
      bankInstitutionId
      plaidAccountId
      tellerAccountId
      retrievedAt
      current
      available
      routingNumber
      institutionName
      bankInstitutionKey
      organizationId
      ownerType
      ownerName
      connectionProviderName
      connectionProviderAccountMask
    }
  }
`;
